export default "__VITE_ASSET__c294f9e3__"